import { DWTableCellEllipsis } from 'src/components/table-cell-ellipsis';
import { registerExtComponent } from '@alife/cn-lowcode-utils';

registerExtComponent(DWTableCellEllipsis.displayName, DWTableCellEllipsis);

export default DWTableCellEllipsis;

export { DWTableCellEllipsis };
